<template>
  <div class="bg">
    <div class="top">
      <div class="bigTitle">
        We are your <span class="blueHighLight">Research Team</span> </br>on the Ground in Asia
      </div>
      <div class="subtitle">
        Holden can guide you to <span class="redHighLight">success</span>
      </div>
    </div>
    <!-- 轮播图 -->
    <el-carousel :interval="4000" type="card" indicator-position="none">

      <el-carousel-item>
        <!-- equote -->
        <a href="https://www.holdendata.com/equote?source=homepage" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Banner_2.png"></a>

      </el-carousel-item>
      <el-carousel-item>
        <!-- appa -->

        <a href="http://appa360.com/?source=holdendataHomePage" target="_blank"> <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Banner_3.png"> </a>
      </el-carousel-item>

      <el-carousel-item>
        <a href="https://www.holdenjapan.com/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Banner_5.png"></a>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图 -->
    <!-- <div class="top">
      <el-carousel ref="carousel" type="card" height="200px" width="500px">
        <el-carousel-item>
          <div class="banner">
            <div class="imgBg eada_imgBg"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/banner_eada.jpg"></div>
            <div class="value value_eada">
              <div class="eada_logo"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/eQuote2.png" alt=""></div>
              <div>Instant Quotation System</div>
              <div style="" class="quotevalue">Asia Quotation Only a Click Away</div>
              <div><button class="banner_button" @click="$router.push('/equote?source=homepage')">Find out more</button></div>
            </div>

          </div>
        </el-carousel-item>

        <el-carousel-item>
          <div class="banner">
            <div class="imgBg"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/banner_appa.jpg"></div>
            <div class="value value_appa">
              Welcome to the Asia Physician Panel Alliance
              <button class="pc d-none d-sm-block"><a href="https://www.appa360.com/?source=appa_holdendata" target="_blank"> Read more</a></button>
            </div>

            <div class="value readmore"> <button class="mobile d-block d-sm-none"><a href="https://www.appa360.com/?source=appa_holdendata" target="_blank"> Read more</a></button></div>

            <div class="appa_logo"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/appa/APPA.png" alt=""></div>

          </div>
        </el-carousel-item>

        <el-carousel-item>
          <div class="banner">
            <div class="imgBg"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/banner1.jpg"></div>
            <div class="value">
              <div> We Are Your Research Team on the Ground in Asia</div>
              <button class="mobile d-block d-sm-none" @click="$router.push('/aboutUs?source=homepage')">Read more</button>
            </div>

          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="banner">
            <div class="imgBg"><img src="@/assets/img/banner_quirksBG.jpg"></div>
            <div class="quirks_left">
              <div><img src="@/assets/img/banner_quirks1.png"></div>
            </div>
            <div class="quirks_right">
              <div><img src="@/assets/img/banner_quirks2.png"></div>
              <div><button class="quirks_button"><a href="https://bluetoad.com/publication/?i=812227&p=38&view=issueViewer" target="_blank"> Read more</a></button></div>

            </div>

          </div>
        </el-carousel-item>
       

      </el-carousel>
    </div> -->

    <!-- 日历 -->
    <!-- <div class="calendar">

      <Carrousel></Carrousel>
      <Carrouselmobile></Carrouselmobile>
    </div> -->

    <!-- 分割区域条 -->
    <div class="titleLine">
      <div class="title">
        Holden Services
      </div>
    </div>
    <!-- 第一部分介绍公司 -->
    <div class="services">
      <div class="servicesBox">
        <div class="box" @click="$router.push('/qual?source=index')">
          <div class="frontimg">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconHealthcare.png">
          </div>
          <div class="backimg">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Qualatitive_Back.png">
          </div>
        </div>
      </div>
      <div class="servicesBox">
        <div class="box" @click="$router.push('/quant?source=index')">
          <div class="frontimg">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconMedtech.png">
          </div>
          <div class="backimg">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Quantitative_Back.png">
          </div>
        </div>
      </div>
      <div class="servicesBox">
        <div class="box" @click="$router.push('/industry?source=index')">
          <div class="frontimg">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconConsumer.png">
          </div>
          <div class="backimg">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Industry_Back.png">
          </div>
        </div>
      </div>
      <div class="servicesBox">
        <div class="box" @click="$router.push('/specialist?source=index')">
          <div class="frontimg">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconAsia.png">
          </div>
          <div class="backimg">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Specialist_Back.png">
          </div>
        </div>
      </div>
    </div>
    <!-- 分割区域条 -->
    <div class="titleLine">
      <div class="title">
        Market Expertise
      </div>
    </div>
    <!-- whyholden  -->
    <asia-map />
    <!-- 分割区域条 -->
    <div class="titleLine">
      <div class="title">
        Holden Products
      </div>
    </div>
    <!-- 浩顿产品 -->
    <div class="products">
      <div class="menu">
        <div class="icon equote" @mouseover="products=1" :class="{menubg:products==1}">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/products_1.png" alt="">
        </div>
        <div class="icon" @mouseover="products=2" :class="{menubg:products==2}">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/products_2.png" alt="">
        </div>
        <div class="icon" @mouseover="products=3" :class="{menubg:products==3}">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/products_3.png" alt="">
        </div>

        <div class="icon" @mouseover="products=5" :class="{menubg:products==5}">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/products_4.png" alt="">
        </div>
      </div>
      <div class="productsValue">
        <div v-if="products==1" class="one">
          <div class="introduce">
            <div class="introduceBox">
              <div style="position: relative;">
                <div class="introduceIMG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/products/eQuote.png" alt=""></div>
                <div class="summary">
                  <div class="title">eQuote</div>
                  <div class="value">eQuote is Holden's proprietary AI tool </br>for instant ballpark costing for conducting fieldwork</div>
                </div>
                <div class="details">
                  <div class="eQuoteValue">
                   eQuote is Holden's proprietary AI tool for instant ballpark costing for conducting fieldwork</br>Anyone, once you register with us, Register with us <span class="redHighLight here" @click="$router.push('/equote?source=index')">HERE</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div v-if="products==2" class="two">

          <div class="introduce">
            <div class="introduceBox">
              <div style="position: relative;">
                <div class="introduceIMG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/products/holdenAnswer.png" alt=""></div>
                <div class="summary">
                  <div class="title">Holden Answer</div>
                  <div class="value">Innovate, Interact, Insight:</br>
                    AME - Your Gateway to Smart Healthcare Research</div>
                </div>
                <div class="details">
                  <div class="holdenAnswerValue">
                    <div class="holdenAnswerOne">
                      <span class="redHighLight">Holden Answer</span> is an <span class="blueHighLight">interactive, Al-enabled interface</span> for market researchers in the healthcare industry.
                    </div>
                    <div class="holdenAnswerTwo">
                      In additional to web trawling functions, and its advanced language model, Holden has built upon it to with its database of both primary and secondary research data to provide both researchers up-to-date and useful market information.
                    </div>
                    <div class="holdenAnswerThree">
                      Friends and clients of Holden can take advantage of non-sensitive primary and secondary research data to supplement their research or simply get to know more about their target markets.Whether you need help with healthcare, research, want to brainstorm ideas, or simply engage in a friendly conversation, Holden Answer is here to provide you with intelligent and interactive assistance.
                    </div>
                    <div class="holdenAnswerButton">
                      <el-button type="primary" @click="toPath('/contact?source=products')">Request A Demo</el-button>
                      <el-button type="primary"><a href="https://www.asiamedeyes.com/#/login" target="_blank">Try It!</a></el-button>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div v-if="products==3" class="three">
          <div class="introduce">
            <div class="introduceBox">
              <div style="position: relative;">
                <div class="introduceIMG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/products/API.png" alt=""></div>
                <div class="summary">
                  <div class="title">API</div>
                  <div class="value">Unlock the full potential of our proprietary products by seamlessly integrating with our custom-developed API.</div>
                </div>
                <div class="details">
                  <div class="APIvalue">
                    <div class="apitop">
                      <div>Unlock the full potential of our proprietary products by seamlessly integrating with our custom-developed API. Empower partners to harness the capabilities of our cutting-edge solutions and enhance their applications with ease.</div>
                    </div>
                    <div style="display:flex" class="api">
                      <div class="apileft">● Seamless Integration:</div>
                      <div class="apiright"> Our API is designed for effortless integration, ensuring a smooth and efficient collaboration between our products and your applications.</div>
                    </div>
                    <div style="display:flex" class="api">
                      <div class="apileft">● Customization:</div>
                      <div class="apiright"> Tailor our solutions to meet your specific needs. Our API allows for flexible customization, enabling partners to adapt and optimize functionality according to their unique requirements.</div>
                    </div>
                    <div style="display:flex" class="api">
                      <div class="apileft">● Efficiency and Productivity:</div>
                      <div class="apiright"> Streamline workflows and boost productivity with the seamless connectivity facilitated by our API, allowing for quick data exchange and real-time updates.</div>
                    </div>
                    <div class="apibottom">
                      <div>Partner with us to take advantage of these benefits and elevate your applications to new heights with our powerful API integration.</div>
                    </div>
                    <div class="apibutton">
                      <el-button type="primary" @click="toPath('/contact?source=products')">Contact Us</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-if="products==5" class="five">
          <div class="introduce">
            <div class="introduceBox">
              <div style="position: relative;">
                <div class="introduceIMG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/products/surveyPanda.png" alt=""></div>
                <div class="summary">
                  <div class="title">Survey Panda</div>
                  <div class="value">Self-developed online data collection platform and reporting system</div>
                </div>
                <div class="details">
                  <div class="surveyPandaValue">
                    Survey Panda is our self-developed online data collection platform and reporting system. SurveyPanda is user friendly and allows for DlY research solutions. At the same time, it is designed to cater for complicated market research requirement.
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- Our Clients Say -->
    <div class="Clients">
      <div class="text">
        <div class="title">
          What our clients say
        </div>
        <div class="value">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/ClientsResponse_MainPage.gif" alt="">

        </div>
      </div>

    </div>
    <!-- 分割区域条 -->
    <div class="titleLine">
      <div class="title">
        Latest News & Release
      </div>
    </div>

    <!-- case study -->
    <!-- <div class="news">
      <div @click="btn('/media')" class="more">read more</div>

      <div class="newsList">

        <div class="one" v-for="(item,index) in caseList.slice(0,4)" :key="index" @click="toDetailcase(item.id)">
          <img :src="item.logo">
          <div class="title">
            {{item.customerTitle}}
          </div>
        </div>

      </div>
    </div> -->
    <!-- news -->
    <!-- <div class="news">
      
      <div class="newsList">
        <div class="topnews">

          <div class="topNews" v-for="(item,index) in topNews.slice(0,1)" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
            <img :src="item.logo">
            <div>
              <div>
                <div class="label">
                  {{item.firstLabel}}
                </div>
                <div class="label" v-for="label in item.othersLabel.split(',').slice(0,3)">
                  {{label}}
   
                </div>
              </div>

              <div class="title">
                {{ item.newsTitle }}
              </div>
            </div>
            <div class="newsDesc overflowMulityText3">
              {{ item.newsDesc }}
            </div>

          </div>
          <div @click="btn('/media?source=index')" class="more">read more</div>
        </div>
        <div class="notopnews">

          <div class="one" v-for="(item,index) in newsList.slice(0,3)" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
            <img :src="item.logo">
            <div>
              <div>
                <div class="label">
                  {{item.firstLabel}}
                </div>
                <div class="label" v-for="label in item.othersLabel.split(',').slice(0,3)">
                  {{label}}
          
                </div>
              </div>

              <div class="title">
                {{ item.newsTitle }}
              </div>
            </div>

          </div>
        </div>

      </div>
    </div> -->
    <el-dialog title="" :visible="DialogShow" width="45%" @close="DialogShow=false">
      <span>
        <div class="from">
          <div class="formtitle">Please fill in your information</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="First Name" prop="firstname">
              <el-input v-model="ruleForm.firstname" />
            </el-form-item>
            <el-form-item label="Last Name" prop="lastname">
              <el-input v-model="ruleForm.lastname" />
            </el-form-item>
            <el-form-item label="Email" prop="mail">
              <el-input v-model="ruleForm.mail" />
            </el-form-item>
            <el-form-item label="Company" prop="company">
              <el-input v-model="ruleForm.company" />
            </el-form-item>
            <el-form-item prop="check" style="width:100%">

              <input class="check" type="checkbox" v-model="ruleForm.check"><span style="word-break: break-word;">Yes, I would like to receive digital communications from Holden brands. I may opt-out of communications at any time using the unsubscribe link at the bottom of any email communication.</span>
            </el-form-item>
          </el-form>

        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogShow = false">cancel</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">submit</el-button>

      </span>
    </el-dialog>
    <news-list />
  </div>
</template>

<script>
// import '@/config/rem'

const defaultForm = {
  action: "News",
  actionCase: "Readnews",
  targetName: "",
  mail: "",
  firstname: "",
  lastname: "",
  company: "",
  check: true
};
import vueSeamlessScroll from "vue-seamless-scroll";
import { getNewsList, getCustomerList, advertisementFlow, actionRecords } from "@/api/api";

import Carrousel from "@/components/swiper.vue";
import Carrouselmobile from "@/components/swiperMobile.vue";
import AsiaMap from "@/components/asiaMap";
import NewsList from "@/components/newsList";

export default {
  name: "Index",
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      rules: {
        firstname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        lastname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        company: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        mail: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { type: "email", message: "Email must be formatted correctly.", trigger: ["blur"] }
        ]
        // check: [{ required: true, message: "Please complete this required field", trigger: "blur" }, { validator: check }]
      },
      DialogShow: false,
      caseList: [],
      slide: 0,
      sliding: null,
      newsList: [],
      isShow: 0,
      topNews: [],
      products: 1,
      activeIndex: 0
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.loading();
    this.getNewsList();
    this.getCustomerList();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    window.addEventListener("load", function() {
      if (window.location.href.includes("https://www.holdendata.com/")) {
        gtag("event", "conversion", { send_to: "AW-11335422054/ry3sCOGp7fYYEOagk50q" });
      }
    });
    this.webinercookies();
    //  this.getNewsList(2);
    // 在组件创建时加载Google代码
  },
  mounted() {
    //调用方法
    this.slideBanner();
  },
  components: {
    vueSeamlessScroll,
    Carrousel,
    Carrouselmobile,
    AsiaMap,
    NewsList
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    },
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    submitForm(formName) {
      let _this = this;
      // 数据写入表单
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.ruleForm.fullName = _this.ruleForm.firstname + " " + _this.ruleForm.lastname;
          let ruleForm = {
            action: "News",
            actionCase: "Readnews",
            firstName: _this.ruleForm.firstname,
            fullName: _this.ruleForm.fullName,
            mail: _this.ruleForm.mail,
            company: _this.ruleForm.company
          };
          //   console.log(this.ruleForm);
          localStorage.setItem("form", JSON.stringify(this.ruleForm));
          var form = JSON.parse(localStorage.getItem("form"));
          form.targetName = this.submitTitle;
          console.log(form);
          // 提交表单数据
          actionRecords(form).then(res => {
            // console.log(form);
            // 如果没有cookie
            // 提交成功
            if (res.code == 10000) {
              // 关闭弹框
              this.DialogShow = false;
              // 如果是同意或者没点，存入cookie
              if (localStorage.getItem("agreeCookies")) {
                var val = localStorage.getItem("agreeCookies");
                var dataobj = JSON.parse(val);
                if (dataobj.val == "agree") {
                  this.$cookies.set("HoldenCookies", "panelDownloads");
                }
              } else if (this.$cookies.isKey("defaultcookies")) {
                this.$cookies.set("HoldenCookies", "panelDownloads");
              }
              // 跳转查看详情
              this.$router.push({ name: "newsDetail", query: { id: this.submitId, source: "index" } });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /*轮播手滑切换*/
    startAuto() {
      if (this.autoplay == false) {
        this.autoplay = true;
      }
    },
    stopAuto() {
      if (this.autoplay == true) {
        this.autoplay = false;
      }
    },
    slideBanner() {
      let that = this;
      //选中item的盒子
      var box = document.querySelector(".el-carousel__container");
      //手指起点X坐标
      var startPoint = 0;
      //手指滑动重点X坐标
      var stopPoint = 0;

      //重置坐标
      var resetPoint = function() {
        startPoint = 0;
        stopPoint = 0;
      };

      //手指按下
      box.addEventListener("touchstart", function(e) {
        //手指按下的时候停止自动轮播
        that.stopAuto();
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function(e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      box.addEventListener("touchend", function(e) {
        console.log(e);
        console.log("1：" + startPoint);
        console.log("2：" + stopPoint);
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.carousel.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.carousel.prev();
          return;
        }
      });
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "index",
          source: "",
          information: "首页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "index",
          source: this.$route.query.source,
          information: "首页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    getCustomerList() {
      getCustomerList({
        pageSize: 4,
        pageIndex: 1,
        status: 1, //启用
        origin: 1, //前台
        isRecommend: 1, //是否推荐
        customerType: 1
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "查询案例分享失败");
          return;
        }
        this.caseList = res.datalist || [];
        this.allCount = res.allCount;
      });
    },
    btn(path) {
      this.$router.push({
        path
      });
    },
    show(num) {
      this.isShow = num;
    },
    toDetailcase(id) {
      this.$router.push({ name: "caseDetail", query: { id: id } });
    },
    toDetail(id, subscribe, newsTitle) {
      if (subscribe == 1 && !this.$cookies.isKey("HoldenCookies")) {
        this.submitId = id;
        this.DialogShow = true;
        this.submitTitle = newsTitle;
      }
      // 如果需要权限并且没有cookie
      else {
        this.$router.push({ name: "newsDetail", query: { id: id, source: "index" } });
      }
    },
    getNewsList() {
      getNewsList({
        pageSize: 0,
        pageIndex: 1,
        status: 1, //启用
        origin: 1 //前台
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "Failed to query news information");
          return;
        } else {
          this.newsList = res.datalist.filter(k => k.topFlag != 1);
          this.topNews = res.datalist.filter(k => k.topFlag == 1);
        }
      });
    }
    // eslint-disable-next-line no-unused-vars
    // format(percentage) {}
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Nunito";
}
.bg {
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Homepage_Background.png");
  background-size: cover;
  color: #1e364e;
  overflow: hidden;
}

/deep/.el-carousel {
  // transform: scale(1.2) !important;
  height: 400px;
  padding-top: 50px;

  .el-carousel__container {
    transform: scale(1.2) !important;
  }
  .el-carousel__item {
    // transform: scale(0.8) !important;
  }
  .is-active {
  }
  img {
    width: 100%;
  }
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.redHighLight {
  color: #e73323;
}
.blueHighLight {
  color: #4c8fd5;
}
.top {
  padding-top: 50px;
  .bigTitle {
    text-align: center;
    font-size: 60px;
    font-weight: 700;
  }
  .subtitle {
    font-size: 20px;
    text-align: center;
    padding: 20px 0;
    // margin-bottom: 50px;
  }
}
.services {
  padding: 0 180px;
  text-align: center;
  perspective: 1000px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .box {
    cursor: pointer;
    width: 200px;
    height: 200px;
    text-align: center;

    transform-style: preserve-3d;
    transition: transform 0.6s;
    position: relative;
    .frontimg {
      background-color: #2cb1e9;
      border-radius: 50%;
      width: 200px;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 60%;
      }
    }
    .frontimg,
    .backimg {
      position: absolute;
      backface-visibility: hidden;
    }
    .backimg {
      transform: rotateY(180deg);
      border-radius: 50%;

      img {
        width: 100%;
      }
    }
  }
}
.servicesBox:hover .box {
  // background-color: #6cdf89;
  transform: rotateY(180deg);
}

.products {
  .menu {
    padding: 0 350px;
    display: flex;
    justify-content: space-around;
    .icon {
      width: 120px;
      height: 120px;
      text-align: center;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      // line-height: 90px;
      // border: 1px solid #000;
      img {
        width: 60%;
      }
    }
    .menubg {
      color: #2cb1e9;
      background-color: #cdf1f5;
    }
  }
  .productsValue {
    background-color: #cdf1f5;
    .introduce {
      position: relative;
      height: 600px;
      margin: 0px 200px;
      display: flex;
      align-items: center;

      .introduceBox {
        position: absolute;
        .introduceIMG {
          img {
            width: 100%;
          }
        }
        .summary {
          position: absolute;
          top: 0;
          padding: 0px 120px;
          .title {
            font-size: 40px;
            font-weight: 700;
            margin: 90px 0;
          }
          .value {
            font-size: 22px;
          }
        }
        .details {
          position: absolute;
          top: 0;
          background-color: #fff;
          position: absolute;
          display: flex;
          align-items: center;
          height: 100%;
          width: 100%;
          opacity: 0;
          transition: all 0.5s;
        }
        .details:hover {
          opacity: 1;
          transform: scale(1.05);
        }
        .eQuoteValue {
          text-align: center;
          // padding: 20px 40px;
          width: 100%;
          .here {
            cursor: pointer;
            text-decoration: underline;
          }
        }
        .holdenAnswerValue {
          text-align: center;
          padding: 50px;
          .holdenAnswerTwo,
          .holdenAnswerThree {
            margin-bottom: 20px;
          }
          .holdenAnswerButton {
            button {
              color: #fff;
              background-color: #90bef9;
              border: none;
            }
            a {
              color: #fff;
              width: 100%;
              height: 100%;
            }
          }
        }
        .APIvalue {
          padding: 20px 40px;
          .apitop {
            margin-bottom: 20px;
            padding: 0 15px;
          }
          .apileft {
            width: 35%;
          }
          .apiright {
            width: 65%;
          }
          .apibottom {
            margin-top: 20px;
          }
          .apibutton {
            text-align: center;
            button {
              color: #fff;
              background-color: #90bef9;
              border: none;
            }
          }
        }
        .surveyPandaValue {
          text-align: center;
          margin: 0 100px;
        }
      }
    }
  }
}
.quotevalue {
  font-size: 25px;
}
// .top {
//   /deep/.el-carousel {
//     height: 590px;

//     .el-carousel__container {
//       height: 590px;
//     }
//   }
//   .el-carousel__item h3 {
//     color: #475669;
//     font-size: 36px;
//     opacity: 0.75;
//     line-height: 300px;
//     margin: 0;
//   }

//   .el-carousel__item:nth-child(2n) {
//   }

//   .el-carousel__item:nth-child(2n + 1) {
//   }
// }
// .banner {
//   // width: 100%;
//   height: 100%;
//   position: relative;
//   .pc {
//     color: #fff;
//     border: none;
//     font-size: 30px;
//     margin: 0 auto;
//     margin-top: 20px;
//   }
//   img {
//     width: 100%;
//   }
//   .value {
//     position: absolute;
//     top: 15%;
//     right: 7%;
//     width: 40%;
//     text-align: center;
//     font-size: 60px;
//     font-weight: 700;
//     color: #003c50;
//     text-shadow: 1px 1px #000;
//   }
//   .value_appa {
//     width: 100%;
//     top: 25%;
//     right: 0;
//     padding: 80px 0;
//   }
//   .appa_logo {
//     position: absolute;
//     width: 360px;
//     height: 360px;
//     background: linear-gradient(#05466b, #68c5ec);
//     right: -30px;
//     top: -120px;
//     border-radius: 50%;
//     box-shadow: 1px 2px 20px #ccc;
//     img {
//       width: 250px;
//       margin-top: 170px;
//       margin-left: 40px;
//     }
//   }
//   .value_eada {
//     width: 100%;
//     height: 100%;
//     left: 0px;
//     padding-left: 100px;
//     padding-top: 100px;
//     color: #fff;
//     // width: 50%;
//     top: 0;
//     text-align: left;
//     font-size: 40px;
//     .eada_logo {
//       font-family: "Cooper Black";
//       font-size: 100px;
//       img {
//         width: 350px;
//       }
//     }
//     .banner_button {
//       font-size: 25px;
//       border: none;
//       color: #fff;
//       background-color: rgba(255, 255, 255, 0.5);
//       padding: 10px;
//       margin-top: 40px;
//     }
//   }
//   .value_intell{
//      color: #fff;
//      font-size: 25px;
//      left: 15%;
//      top: 85%;
//      cursor: pointer;
//   }
//   .quirks_left {
//     position: absolute;
//     top: 10%;
//     left: 5%;
//     width: 40%;
//     text-align: center;
//     img {
//       width: 60%;
//     }
//   }
//   .quirks_right {
//     position: absolute;
//     top: 30%;
//     right: 7%;
//     width: 50%;
//     text-align: center;
//     img {
//       width: 100%;
//     }
//     .quirks_button {
//       background-color: #2cb1e9;
//       color: #fff;
//       font-size: 30px;
//       background-color: #2cb1e9;
//       border: 1px solid #2cb1e9;
//       border-radius: 5px;
//       margin-top: 10%;
//       padding: 10px 20px;
//       font-weight: 700;
//     }
//   }
// }

.titleLine {
  font-weight: 700;
  .title {
    font-size: 40px;
  }
  .value {
    color: #86898d;
    font-size: 20px;
    padding: 0 200px;
  }
  img {
    width: 250px;
  }
  text-align: center;
  // margin: 1rem auto;
  padding: 80px 80px 40px;
}
.Clients {
  text-align: center;
  padding-top: 80px;
  .text {
    .title {
      // padding: 100px 100px 0 100px;

      font-size: 35px;
      font-weight: 700;
      color: #003c50;
    }
    .value {
      width: 100%;
      text-align: center;
      vertical-align: center;
      padding: 50px 150px;
      padding-bottom: 10px;
      font-weight: 700;
      img {
        width: 100%;
      }
    }
  }
}
.news {
  // background-color: #fff;
  padding: 0 120px;
  font-size: 18px;
  position: relative;
  .more {
    // width: 160px;
    padding: 0 20px;
    font-size: 16px;
    color: #409eff;
    background-color: #ecf5ff;
    border: 1px solid #409eff;
    border-radius: 8px;
    text-align: center;
    position: absolute;
    left: 120px;
    bottom: 30px;
  }
  .more:hover {
    cursor: pointer;
    color: #2cb1e9;
  }
  .newsList {
    // text-align: center;
    display: flex;
    justify-content: space-between;
    // flex-wrap: wrap;
    .topnews {
      width: 50%;
      height: 100%;
      background-color: #fff;

      .topNews {
        border: 1px solid #d5dbe5;
        border-radius: 8px;
        box-shadow: 4px 4px 4px 0 #d5dbe5;
        padding: 14px;
        cursor: pointer;

        img {
          width: 100%;
        }
        .title {
          // margin-top: 10px;
          font-weight: 700;
        }
        .label {
          margin: 15px 10px 0 0;
          font-size: 12px;
          display: inline-block;
          padding: 0.7px 7.5px 2px;
          background: #e8f2ff;
          border-radius: 4px;
          color: #2186c8;
        }
        .newsDesc {
          margin-top: 20px;
        }
      }
    }
    .notopnews {
      width: 47%;
    }
    .one {
      background-color: #fff;
      display: flex;
      cursor: pointer;
      padding: 14px;
      width: 100%;
      margin: 0px auto 20px;
      border: 1px solid #d5dbe5;
      border-radius: 8px;
      box-shadow: 4px 4px 4px 0 #d5dbe5;
      img {
        width: 300px;
        height: 170px;
      }
      .title {
        margin-left: 10px;
      }
      .label {
        margin-left: 10px;
        font-size: 12px;
        display: inline-block;
        padding: 0.7px 7.5px 2px;
        background: #e8f2ff;
        border-radius: 4px;
        color: #2186c8;
      }
    }
    .two {
      width: 40%;
    }
  }
}
.check {
  margin-right: 10px;
}
.from {
  // width: 60%;
  // margin: 80px auto;
  // padding: 30px;
  // transform: scale(1.3);
  padding-top: 0px;
  .formtitle {
    text-align: center;
    font-weight: 700;
    font-size: 25px;
    color: #ff0000;
  }
  @media screen and (max-width: 570px) {
    .formtitle {
      font-size: 45px;
    }
  }
  .el-form {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    padding: 10px;
    /deep/ .el-form-item {
      display: inline-block;
      display: flex;
      // flex-wrap: wrap;
      justify-content: start;
      &:nth-child() {
        .el-form-item__label {
          // margin-left: 7px;
        }
      }
      &:not(.text) {
        // width: 50%;
      }
      &.text {
        width: 100%;
      }
      .el-form-item__content {
        font-size: 11px;
        line-height: 20px;
        flex: 1;
        .el-input {
          width: 238px !important;
        }
      }

      .el-form-item__label {
        width: 125px;
        font-size: 15px;
        display: block;
        font-weight: normal;
      }
      .el-textarea__inner {
        min-height: 104px !important;
      }
      .el-input__inner,
      .el-textarea__inner {
        background: #fafafa;
        border: 1px solid #e6e6e6;
        border-radius: 7px;
        font-size: 15px;
        width: 390px;
      }
      @media screen and (max-width: 576px) {
        .el-input__inner {
          font-size: 35px;
          width: 700px;
          height: 80px;
        }
        .el-form-item__label {
          font-size: 35px;
          width: 250px;
        }
        .el-form-item__content {
          font-size: 30px;
          line-height: 40px;
        }
      }
      .el-form-item__error {
        font-size: 12px !important;
      }
    }
  }
  & > * {
    margin: 20px;
  }
  div {
    margin-top: 12px;
  }
  .button {
    margin: 0 auto;
    margin-top: 20px;
    background: #217df6;
    font-size: 13px;
    color: #fff;
    border-radius: 7px;
    text-align: center;
    width: 150px;
    padding: 10px;
    // height: 34px;
    // line-height: 34px;
    cursor: pointer;
  }
  @media screen and (max-width: 576px) {
    .button {
      font-size: 35px;
    }
  }
}
@media screen and (max-width: 576px) {
  .quotevalue {
    font-size: 80px;
  }
  .top {
    /deep/.el-carousel {
      height: 1800px;

      .el-carousel__container {
        height: 1800px;
      }
    }
  }

  .banner {
    .value {
      width: 85%;
      font-size: 140px;
      button {
        font-size: 80px;
        margin: 0 auto;
        margin-top: 150px;
        padding: 30px;
        background-color: #2cb1e9;
        color: #fff;
        border: none;
      }
    }
    .readmore {
      top: 70%;
    }

    .imgBg {
      img {
        height: 1800px;
        width: auto;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .eada_imgBg {
      img {
        right: -1400px;
      }
    }
    .value_appa {
      width: 100%;
      top: 20%;
    }
    .appa_logo {
      width: 500px;
      height: 500px;

      img {
        width: 400px;
        height: auto;
        margin-top: 200px;
      }
    }
    .value_eada {
      width: 100%;
      padding-top: 300px;
      padding-left: 130px;
      .eada_logo {
        img {
          width: 800px;
        }
      }
      .banner_button {
        font-size: 70px;
        padding: 10px 30px;
      }
    }
    .value_intell {
      background-color: rgba(255, 255, 255, 0.5);
      font-size: 85px;
      width: 800px;
      padding: 50px;
      left: 5%;
      top: 65%;
    }
    .quirks_left {
      width: 80%;
      left: 10%;
      top: 5%;
    }
    .quirks_right {
      top: 65%;
      right: 5%;
      width: 88%;
      .quirks_button {
        font-size: 75px;
        margin-top: 5%;
      }
    }
  }
  .Clients {
    height: 900px;
    .text {
      .title {
        font-size: 70px;
      }
      .value {
        font-size: 55px;
      }
    }
    /deep/.el-carousel {
      height: 600px;

      .el-carousel__container {
        height: 600px;
      }
    }
  }
  .titleLine {
    padding: 120px;
    .title {
      font-size: 80px;
    }
    img {
      width: 500px;
    }
    .value {
      font-size: 40px;
    }
  }
  .message {
    .box {
      width: 100%;
      margin-bottom: 150px;
      height: 900px;
      img {
        width: 400px;
      }
      .value {
        font-size: 70px;
      }
    }
  }
  .solutions {
    .solutionstext {
      font-size: 70px;
    }
    .annotation {
      font-size: 23px;
    }
    .title {
      font-size: 60px;
    }
    .value {
      display: block;
      .solutionsValue {
        width: 100%;
        .solutionbox {
          padding: 20px;
          // width: 100%;
        }

        .text {
          span {
            font-size: 70px;
          }
          div {
            font-size: 70px;
          }
        }
      }
    }
  }
  i {
    font-size: 100px;
  }
  .things {
    .left,
    .right {
      font-size: 65px;
      height: 500px;
    }
    .title {
      font-size: 60px;
    }
    .value {
      font-size: 40px;
      .d-block {
        display: inline-block !important;
      }
      .left,
      .right {
        width: 100%;
        div {
          margin-top: 40px;
        }
      }
    }
  }
  .experience {
    padding: 0 50px 100px;
    .data {
      padding: 50px 0;
      .box {
        .num {
          font-size: 50px;
        }
        .detatil {
          font-size: 25px;
        }
      }
    }
  }
  .products {
    .menu {
      .icon {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        width: 350px;
        height: 230px;
        font-size: 40px;
        i {
          font-size: 80px;
          width: 100%;
        }
      }
    }
    .productsValue {
      .holdenanswer {
        flex-wrap: wrap;
        img {
          width: 100%;
          margin-bottom: 30px;
        }
      }
      .apiimg {
        flex-wrap: wrap;
        img {
          width: 100%;
        }
      }
      .api {
        flex-wrap: wrap;
        .apileft {
          width: 100%;
        }
        .apiright {
          width: 100%;
        }
      }
      .two,
      .three,
      .four {
        .title {
          font-size: 80px;
        }
        .value {
          font-size: 70px;
        }
        .button {
          .el-button {
            font-size: 70px;
            padding: 30px;
          }
        }
      }
    }
  }
  .SurveyPanda {
    display: block;
    position: relative;
    padding-top: 600px;
    .img {
      position: absolute;
      top: 100px;
      width: 80%;
    }
    .text {
      width: 90%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }
  .doctors {
    .three {
      width: 47%;
      padding: 20px;
      margin-bottom: 50px;
      .doctorName {
        font-size: 50px;
      }
      .doctorValue {
        font-size: 40px;
      }
    }
  }
  .news {
    padding-bottom: 100px;
    .more {
      font-size: 40px;
      bottom: 10px;
    }
    .newsList {
      display: block;
      .topnews {
        width: 100%;
        .topNews {
          .title {
            font-size: 70px;
          }
          .label {
            font-size: 50px;
            margin-bottom: 10px;
          }
          .newsDesc {
            font-size: 60px;
          }
        }
      }
      .notopnews {
        width: 100%;
      }
      .one {
        flex-wrap: wrap;
        img {
          width: 100%;
          height: 800px;
        }
        .label {
          font-size: 50px;
          margin-bottom: 10px;
        }
        .title {
          font-size: 70px;
        }
      }
    }
  }
  /deep/ .el-dialog__wrapper {
    .el-dialog {
      width: 100% !important;
      .el-dialog__footer {
        .el-button {
          font-size: 70px;
          padding: 20px;
        }
      }
    }
  }
}
</style>
